import React, { ReactElement } from 'react';

import { ColumnType } from '@philips-emr/tws-components-api';
import { TextAlignment } from '@philips-emr/tws-constants';
import { ClickEvent } from '@philips-emr/tws-core/lib/component/types';
import { classNames, isEnumValid, isFunction } from '@philips-emr/tws-utils';

type Children = ReactElement | ReactElement[] | null | string;

interface DataTableCellProps {
  alignment?: TextAlignment;
  children: Children;
  className?: string;
  onClick?: (event: ClickEvent) => void;
  type?: ColumnType;
  width?: number;
}

interface Styles {
  width?: string;
}

function isBoolean(value: any): value is boolean {
  return typeof value === 'boolean';
}

function getClassName(props: DataTableCellProps): string {
  const { alignment, className = '' } = props;

  const names = {
    'c-data-table__cell': true,
    'u-truncate': true,
    [`u-text-${alignment}`]: isEnumValid(TextAlignment, alignment),
    [className]: Boolean(className),
  };

  return classNames(names);
}

function getStyle(props: DataTableCellProps): Styles {
  const { width } = props;

  const styles: Styles = {};

  if (width) {
    styles.width = `${width}px`;
  }

  return styles;
}

function getCellValue(props: DataTableCellProps): Children {
  const { children } = props;

  if (isBoolean(children)) {
    return String(children);
  }

  return children;
}

function DataTableCell(props: DataTableCellProps): ReactElement {
  const { onClick } = props;

  const clickFn = (): void => {
    if (isFunction(onClick)) {
      onClick(new ClickEvent());
    }
  };

  const value = getCellValue(props);

  return (
    <div className={getClassName(props)} onClick={clickFn} style={getStyle(props)}>
      {value}
    </div>
  );
}

export default DataTableCell;
